<template>
  <main id="rpg-view"></main>
</template>

<script>
import Phaser from 'phaser';

export default {
  name: 'RpgView',
  mounted() {
    import('./src/index.js').then((rpgGame) => {
      this.$nextTick(() => {
        Phaser.Plugins.PluginCache.removeCustom('rexOutlinePipeline');
        Phaser.Plugins.PluginCache.remove('PhaserNavMeshPlugin');

        const RPG = rpgGame.launch();

        window.addEventListener(
          'popstate',
          () => {
            RPG.destroy(true);
          },
          false,
        );
      });
    });
  },
};
</script>

<style scoped>
#rpg-view {
  display: flex;
  justify-content: center;
  height: 100vh;
}
</style>
